'use client';

import { useClientTranslation } from '@/hook/translate';
import clsx from 'clsx';
import { Image } from '@nextui-org/react';
import { useState } from 'react';
import { listenBrief } from '@/types/audioResData';
import MobileBookList from './MobileBookList';
import { MindfulAudioImg } from '@/config/img/mindfulAudio';
import { useParams } from 'next/navigation';

interface IProps {
  bookList: listenBrief.TReaderBook[];
}

export default function MobileReaderContent(props: IProps) {
  const [show, setShow] = useState(true);
  const { t } = useClientTranslation();
  const params = useParams();
  return (
    <div className='reader-enjoyed pt-10'>
      <div className='flex'>
        <h2 className={'pr-2 w-3/4 text-22-30 font-extrabold'}>
          {t('readerEnjoyedSummary', 'mindfulAudio')}
        </h2>
        <div className="img flex-1 flex items-center justify-end">
        <Image className={clsx(show ? 'block' : 'hidden', 'cursor-pointer')} src={MindfulAudioImg.ReaderDown} width={20} height={20} alt='down' onClick={() => setShow(false)} />
        <Image className={clsx(!show ? 'block' : 'hidden', 'cursor-pointer')} src={MindfulAudioImg.Triangle} width={20} height={20} alt='down' onClick={() => setShow(true)} />
        </div>
      </div>
      <div className={ clsx('book-list pt-5', show ? 'block' : 'hidden') }>
        <MobileBookList bookList={ props.bookList } lng={params.lng as string} />
      </div>
    </div>
  );
}
